import { Grid } from "@material-ui/core";
import { InputTextMaster } from "App/Component/ui";

import React from "react";

function TabProfile({ formData }) {
  return (
    <Grid container>
      <Grid item sm={12}>
        <InputTextMaster
          name='nik'
          label='NIK'
          disabled={true}
          readOnly={true}
          id='nik'
          value={formData.nik}
          placeholder=''
        />
      </Grid>
      <Grid item sm={12}>
        <InputTextMaster
          name='hak_kelas'
          label='HAK KELAS'
          disabled={true}
          readOnly={true}
          id='hak_kelas'
          value={formData.hak_kelas}
          placeholder=''
        />
      </Grid>
      <Grid item sm={12}>
        <InputTextMaster
          name='asal_rujukan'
          label='ASAL RUJUKAN'
          disabled={true}
          readOnly={true}
          id='asal_rujukan'
          value={formData.ppk_rujukan_name}
          placeholder=''
        />
      </Grid>
      <Grid item sm={12}>
        <InputTextMaster
          name='tgl_rawat'
          label='TGL RAWAT'
          disabled={true}
          readOnly={true}
          id='tgl_rawat'
          type='date'
          value={formData.tgl_pelayanan}
          placeholder=''
        />
      </Grid>
      <Grid item sm={12}>
        <InputTextMaster
          name='pekerjaan'
          label='PEKERJAAN'
          disabled={true}
          readOnly={true}
          id='pekerjaan'
          value={formData.pekerjaan}
          placeholder=''
        />
      </Grid>
    </Grid>
  );
}

export default TabProfile;
